import lazyLoading from './lazyLoading';

/* eslint-disable */
export default {
  routes: [
    { path: '/',                      component: lazyLoading('FlowMenu'),                          name: 'h' },
    { path: '/mp',                    component: lazyLoading('Home'),                             name: 'mp' },
    { path: '/bad',                   component: lazyLoading('Home'),                            name: 'bad' },
    { path: '/noCC',                  component: lazyLoading('NoCC'),                            name: 'noCC'},
    { path: '/faqs',                  component: lazyLoading('Faqs'),                           name: 'faqs' },
    { path: '/claro',                 component: lazyLoading('Home'),                          name: 'claro' },
    { path: '/offer',                 component: lazyLoading('Home'),                          name: 'offer' },
    { path: '/setPin',                component: lazyLoading('SetPin'),                       name: 'setPin' },
    { path: '/actions',               component: lazyLoading('Home'),                        name: 'actions' },
    { path: '/roaming',               component: lazyLoading('Roaming'),                     name: 'roaming' },
    { path: '/hasBill',               component: lazyLoading('HasBill'),                     name: 'hasBill' },
    { path: '/payForm',               component: lazyLoading('PayForm'),                     name: 'payForm' },
    { path: '/canDoMP',               component: lazyLoading('Home'),                        name: 'canDoMP' },
    { path: '/history',               component: lazyLoading('History'),                     name: 'history' },
    { path: '/recharge',              component: lazyLoading('Recharge'),                    name: 'recharge'},
    { path: '/packages',              component: lazyLoading('Packages'),                   name: 'packages' },
    { path: '/typeMenu',              component: lazyLoading('TypeMenu'),                   name: 'typeMenu' },
    { path: '/setNumber',             component: lazyLoading('SetNumber'),                 name: 'setNumber' },
    { path: '/pagosaldo',             component: lazyLoading('PayBalance'),                name: 'pagosaldo' },
    { path: '/payOptions',            component: lazyLoading('Home'),                     name: 'payOptions' },
    { path: '/creditLine',            component: lazyLoading('CreditLine'),               name: 'creditLine' },
    { path: '/hasBalance',            component: lazyLoading('HasBalance'),               name: 'hasBalance' },
    { path: '/sponsorship',           component: lazyLoading('Sponsorship'),             name: 'sponsorship' },
    { path: '/MCpayOption',           component: lazyLoading('Home'),                    name: 'MCpayOption' },
    { path: '/CCpayOption',           component: lazyLoading('Home'),                    name: 'CCpayOption' },
    { path: '/registerNew',           component: lazyLoading('Home'),                    name: 'registerNew' },
    { path: '/PVpayOption',           component: lazyLoading('Home'),                    name: 'PVpayOption' },
    { path: '/clientProfile',         component: lazyLoading('ClientProfile'),         name: 'clientProfile' },
    { path: '/hasMobileData',         component: lazyLoading('HasMobileData'),         name: 'hasMobileData' },
    { path: '/checkOperator',         component: lazyLoading('Home'),                  name: 'checkOperator' },
    { path: '/renovacionauto',        component: lazyLoading('AutoRenew'),            name: 'renovacionauto' },
    { path: '/MPrenovationCheck',     component: lazyLoading('Home'),              name: 'MPrenovationCheck' },
    { path: '/CCrenovationCheck',     component: lazyLoading('Home'),              name: 'CCrenovationCheck' },
    { path: '/acceptSponsorship',     component: lazyLoading('AcceptSponsorship'), name: 'acceptSponsorship' },
    { path: '/profile',               component: lazyLoading('Profile'),                      name: 'profile',
      children: [
        { path: '/', component: lazyLoading('Balance'), name: 'balance' },
        { path: 'quota', component: lazyLoading('Quota'), name: 'quota' }
      ]
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (to.query.goTo) {
      return {
        selector: to.query.goTo
      };
    }
    return savedPosition;
  }
};
/* eslint-disable */



// WEBPACK FOOTER //
// ./src/router/claro.js